import { useEffect } from 'react';
import Phelebotomy from './Phelebotomy/Phelebotmy';
import Accessioning from './Accessioning/Accessioning';

const useMountEffect = fun => useEffect(fun, []);

export default useMountEffect;


